// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_container {
  width: 100%;
  min-height: 100vh;
  background-color: #151018;
  position: relative;
  padding-bottom: 1rem;
}
.profile_container .profile_header {
  width: 100%;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
  display: flex;
}
.profile_container .profile_header .profile_logo {
  width: 15%;
  display: flex;
  align-items: center;
  position: relative;
}
.profile_container .profile_header .profile_logo img {
  width: 30%;
  margin-left: 30%;
}
.profile_container .profile_header .profile_logo .back {
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 46.34px;
  height: 46.34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: #FFFFFF;
  background-color: #231B27;
  border: 1px solid #231B27;
  border-radius: 0.4rem;
}
.profile_container .profile_header .profile_logo .back:hover {
  background-color: #2a202e;
  color: rgb(214, 65, 10);
}
.profile_container .profile_header .profile_search {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.profile_container .profile_header .profile_search .input {
  width: 100%;
  height: 46.34px;
  padding: 0.48rem 1rem;
  outline: none;
  background-color: #231B27;
  border-radius: 0.6rem;
  border: 1px solid #231B27;
  color: #898989;
  font-size: 1.2rem;
}
.profile_container .profile_header .profile_search .input::placeholder {
  color: #898989;
}
.profile_container .profile_header .profile_avatar {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.profile_container .profile_header .profile_avatar .avatar {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #bababa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: 0.1s linear;
}
.profile_container .profile_header .profile_avatar .avatar:hover {
  background-color: #e8e5e5;
  color: rgb(214, 65, 10);
  font-size: 1.5rem;
}
.profile_container .profile_header .profile_avatar .sub_list {
  width: 80%;
  margin: 0 auto;
  padding: 0.5rem 0.2rem;
  background-color: #231B27;
  position: absolute;
  bottom: -3.5rem;
  border-radius: 0.6rem;
  z-index: 10;
}
.profile_container .profile_header .profile_avatar .sub_list .item {
  display: block;
  margin: 0.4rem 1rem;
  text-decoration: none;
  color: #FFFFFF;
}
.profile_container .profile_header .profile_avatar .sub_list .item:hover {
  color: rgb(214, 65, 10);
}
.profile_container .profile_content {
  width: 70%;
  margin: 0 auto;
  padding: 0 1rem;
}
.profile_container .profile_content h2 {
  color: #FFFFFF;
  margin: 1.6rem 0;
  font-size: 2rem;
}
.profile_container .profile_content .profile_settings {
  width: 55.1875rem;
  height: 27rem;
  background-color: #231B27;
  padding: 1.5rem;
  border-radius: 0.8rem;
  font-size: 80%;
}
.profile_container .profile_content .profile_settings .options {
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  gap: 1rem;
  margin-top: 1rem;
}
.profile_container .profile_content .profile_settings .options li {
  list-style: none;
  color: #e8e5e5;
  border-bottom: 1px solid #e8e5e5;
  cursor: pointer;
}
.profile_container .profile_content .profile_settings form .profile_details_content {
  width: 100%;
  padding: 0.6rem 0.5rem;
  display: flex;
}
.profile_container .profile_content .profile_settings form .profile_details_content_left, .profile_container .profile_content .profile_settings form .profile_details_content .manage_user_left {
  width: 50%;
}
.profile_container .profile_content .profile_settings form .profile_details_content_left .input_block, .profile_container .profile_content .profile_settings form .profile_details_content .manage_user_left .input_block {
  display: flex;
  flex-direction: column;
  margin: 0.8rem 0;
}
.profile_container .profile_content .profile_settings form .profile_details_content_left .input_block label, .profile_container .profile_content .profile_settings form .profile_details_content .manage_user_left .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.profile_container .profile_content .profile_settings form .profile_details_content_left .input_block input, .profile_container .profile_content .profile_settings form .profile_details_content .manage_user_left .input_block input {
  width: 95%;
  height: 2.8rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.profile_container .profile_content .profile_settings form .profile_details_content_right {
  width: 50%;
}
.profile_container .profile_content .profile_settings form .profile_details_content_right .input_block {
  display: flex;
  flex-direction: column;
  margin: 0.8rem 0;
  padding-left: 5%;
}
.profile_container .profile_content .profile_settings form .profile_details_content_right .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.profile_container .profile_content .profile_settings form .profile_details_content_right .input_block input,
.profile_container .profile_content .profile_settings form .profile_details_content_right .input_block select {
  width: 100%;
  height: 2.8rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.profile_container .profile_content .profile_settings form .profile_details_content_btns {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0.5rem;
}
.profile_container .profile_content .profile_settings form .profile_details_content_btns button {
  width: 5rem;
  padding: 0.5rem 0.2rem;
  cursor: pointer;
  outline: none;
  border: none;
  border-radius: 0.3rem;
  color: #bababa;
  font-weight: 600;
  font-size: 1rem;
}
.profile_container .profile_content .profile_settings form .profile_details_content_btns .save {
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
}
.profile_container .profile_content .profile_settings form .password_content {
  display: flex;
}
.profile_container .profile_content .profile_settings form .password_content .password_left {
  width: 50%;
}
.profile_container .profile_content .profile_settings form .password_content .password_left .input_block {
  display: flex;
  flex-direction: column;
  margin: 4rem 0;
  padding-left: 5%;
}
.profile_container .profile_content .profile_settings form .password_content .password_left .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.profile_container .profile_content .profile_settings form .password_content .password_left .input_block input {
  width: 95%;
  height: 3rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.profile_container .profile_content .profile_settings form .password_content .password_right {
  width: 50%;
}
.profile_container .profile_content .profile_settings form .password_content .password_right .input_block {
  display: flex;
  flex-direction: column;
  margin: 4rem 0;
  padding-left: 5%;
}
.profile_container .profile_content .profile_settings form .password_content .password_right .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.profile_container .profile_content .profile_settings form .password_content .password_right .input_block input {
  width: 95%;
  height: 3rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.profile_container .profile_content .profile_settings form .password_btns {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0.5rem;
}
.profile_container .profile_content .profile_settings form .password_btns button {
  width: 5rem;
  padding: 0.5rem 0.2rem;
  cursor: pointer;
  outline: none;
  border: none;
  border-radius: 0.3rem;
  color: #bababa;
  font-weight: 600;
  font-size: 1rem;
}
.profile_container .profile_content .profile_settings form .password_btns .save {
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
}
.profile_container .profile_content .profile_settings form .manage_user_content {
  width: 50%;
}
.profile_container .profile_content .profile_settings form .manage_user_content .manage_user_left .input_block {
  display: flex;
  flex-direction: column;
  margin: 4rem 0;
  padding-left: 5%;
}
.profile_container .profile_content .profile_settings form .manage_user_content .manage_user_left .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.profile_container .profile_content .profile_settings form .manage_user_content .manage_user_left .input_block input {
  width: 95%;
  height: 3rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.profile_container .profile_content .profile_settings form .manage_user_password_btns {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0.5rem;
}
.profile_container .profile_content .profile_settings form .manage_user_password_btns button {
  width: 10rem;
  padding: 0.5rem 0.2rem;
  cursor: pointer;
  outline: none;
  border: none;
  border-radius: 0.3rem;
  color: #bababa;
  font-weight: 600;
  font-size: 1rem;
}
.profile_container .profile_content .profile_settings form .manage_user_password_btns .save {
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
}`, "",{"version":3,"sources":["webpack://./src/components/profile/_Profile.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACI,WAAA;EACA,kCAAA;EACA,aAAA;AACR;AACQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AACY;EACI,UAAA;EACA,gBAAA;AAChB;AAEY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAAhB;AAEgB;EACI,yBAAA;EACA,uBAAA;AAApB;AAKQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AAHhB;AAKgB;EACI,cAAA;AAHpB;AAQQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AANZ;AAQY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AANhB;AAQgB;EACI,yBAAA;EACA,uBAAA;EACA,iBAAA;AANpB;AAUY;EACI,UAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,qBAAA;EACA,WAAA;AAThB;AAWgB;EACI,cAAA;EAEA,mBAAA;EACA,qBAAA;EACA,cAAA;AAVpB;AAYoB;EACI,uBAAA;AAVxB;AAiBI;EACI,UAAA;EACA,cAAA;EACA,eAAA;AAfR;AAiBQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAfZ;AAkBQ;EACI,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAhBhB;AAkBgB;EACI,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AAhBpB;AAsBoB;EACI,WAAA;EACA,sBAAA;EACA,aAAA;AApBxB;AAsBwB;EACI,UAAA;AApB5B;AAsB4B;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AApBhC;AAsBgC;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AApBpC;AAuBgC;EACI,UAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AArBpC;AA0BwB;EACI,UAAA;AAxB5B;AA0B4B;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAxBhC;AA0BgC;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAxBpC;AA2BgC;;EAEI,WAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAzBpC;AA8BwB;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;AA5B5B;AA8B4B;EACI,WAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA5BhC;AA+B4B;EACI,6DAAA;AA7BhC;AAmCgB;EACI,aAAA;AAjCpB;AAmCoB;EACI,UAAA;AAjCxB;AAmCwB;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAjC5B;AAmC4B;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAjChC;AAoC4B;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAlChC;AAuCoB;EACI,UAAA;AArCxB;AAuCwB;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AArC5B;AAuC4B;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AArChC;AAwC4B;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAtChC;AA4CgB;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;AA1CpB;AA4CoB;EACI,WAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA1CxB;AA6CoB;EACI,6DAAA;AA3CxB;AA+CgB;EACI,UAAA;AA7CpB;AAgDwB;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AA9C5B;AAgD4B;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AA9ChC;AAiD4B;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AA/ChC;AAqDgB;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;AAnDpB;AAqDoB;EACI,YAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAnDxB;AAsDoB;EACI,6DAAA;AApDxB","sourcesContent":[".profile_container {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #151018;\n    position: relative;\n    padding-bottom: 1rem;\n\n    .profile_header {\n        width: 100%;\n        padding: 2rem 1.5rem .2rem 1.5rem;\n        display: flex;\n\n        .profile_logo {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            img{\n                width: 30%;\n                margin-left: 30%;\n            }\n\n            .back {\n                position: absolute;\n                right: .4rem;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 46.34px;\n                height: 46.34px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                color: #FFFFFF;\n                background-color: #231B27;\n                border: 1px solid #231B27;\n                border-radius: .4rem;\n\n                &:hover {\n                    background-color: #2a202e;\n                    color: rgb(214, 65, 10);\n                }\n            }\n        }\n\n        .profile_search {\n            width: 70%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            .input {\n                width: 100%;\n                height: 46.34px;\n                padding: .48rem 1rem;\n                outline: none;\n                background-color: #231B27;\n                border-radius: .6rem;\n                border: 1px solid #231B27;\n                color: #898989;\n                font-size: 1.2rem;\n\n                &::placeholder {\n                    color: #898989;\n                }\n            }\n        }\n\n        .profile_avatar {\n            width: 15%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            user-select: none;\n\n            .avatar {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #bababa;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                transition: .1s linear;\n\n                &:hover {\n                    background-color: #e8e5e5;\n                    color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n            }\n\n            .sub_list {\n                width: 80%;\n                margin: 0 auto;\n                padding: .5rem .2rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -3.5rem;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .item {\n                    display: block;\n                    // text-align: center;\n                    margin: .4rem 1rem;\n                    text-decoration: none;\n                    color: #FFFFFF;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                    }\n                }\n            }\n        }\n    }\n\n    .profile_content {\n        width: 70%;\n        margin: 0 auto;\n        padding: 0 1rem;\n\n        h2 {\n            color: #FFFFFF;\n            margin: 1.6rem 0;\n            font-size: 2rem;\n        }\n\n        .profile_settings {\n            width: 55.1875rem;\n            height: 27rem;\n            background-color: #231B27;\n            padding: 1.5rem;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            .options {\n                display: flex;\n                font-size: 1rem;\n                font-weight: 500;\n                gap: 1rem;\n                margin-top: 1rem;\n\n                li {\n                    list-style: none;\n                    color: #e8e5e5;\n                    border-bottom: 1px solid #e8e5e5;\n                    cursor: pointer;\n                }\n            }\n\n            form {\n                .profile_details {\n                    &_content {\n                        width: 100%;\n                        padding: .6rem .5rem;\n                        display: flex;\n\n                        &_left, .manage_user_left {\n                            width: 50%;\n\n                            .input_block {\n                                display: flex;\n                                flex-direction: column;\n                                margin: .8rem 0;\n\n                                label {\n                                    font-weight: 400;\n                                    font-size: 1rem;\n                                    color: #FFFFFF;\n                                }\n\n                                input {\n                                    width: 95%;\n                                    height: 2.8rem;\n                                    outline: none;\n                                    padding-left: .5rem;\n                                    background-color: #231B27;\n                                    border: .12rem solid #FFFFFF;\n                                    border-radius: .3rem;\n                                    color: #FFFFFF;\n                                    font-weight: 600;\n                                }\n                            }\n                        }\n\n                        &_right {\n                            width: 50%;\n\n                            .input_block {\n                                display: flex;\n                                flex-direction: column;\n                                margin: .8rem 0;\n                                padding-left: 5%;\n\n                                label {\n                                    font-weight: 400;\n                                    font-size: 1rem;\n                                    color: #FFFFFF;\n                                }\n\n                                input,\n                                select {\n                                    width: 100%;\n                                    height: 2.8rem;\n                                    outline: none;\n                                    padding-left: .5rem;\n                                    background-color: #231B27;\n                                    border: .12rem solid #FFFFFF;\n                                    border-radius: .3rem;\n                                    color: #FFFFFF;\n                                    font-weight: 600;\n                                }\n                            }\n                        }\n\n                        &_btns {\n                            display: flex;\n                            justify-content: flex-end;\n                            padding: 1rem .5rem;\n\n                            button {\n                                width: 5rem;\n                                padding: .5rem .2rem;\n                                cursor: pointer;\n                                outline: none;\n                                border: none;\n                                border-radius: .3rem;\n                                color: #bababa;\n                                font-weight: 600;\n                                font-size: 1rem;\n                            }\n\n                            .save {\n                                background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                            }\n                        }\n                    }\n                }\n\n                .password_content {\n                    display: flex;\n\n                    .password_left {\n                        width: 50%;\n\n                        .input_block {\n                            display: flex;\n                            flex-direction: column;\n                            margin: 4rem 0;\n                            padding-left: 5%;\n\n                            label {\n                                font-weight: 400;\n                                font-size: 1rem;\n                                color: #FFFFFF;\n                            }\n\n                            input {\n                                width: 95%;\n                                height: 3rem;\n                                outline: none;\n                                padding-left: .5rem;\n                                background-color: #231B27;\n                                border: .12rem solid #FFFFFF;\n                                border-radius: .3rem;\n                                color: #FFFFFF;\n                                font-weight: 600;\n                            }\n                        }\n                    }\n\n                    .password_right {\n                        width: 50%;\n\n                        .input_block {\n                            display: flex;\n                            flex-direction: column;\n                            margin: 4rem 0;\n                            padding-left: 5%;\n\n                            label {\n                                font-weight: 400;\n                                font-size: 1rem;\n                                color: #FFFFFF;\n                            }\n\n                            input {\n                                width: 95%;\n                                height: 3rem;\n                                outline: none;\n                                padding-left: .5rem;\n                                background-color: #231B27;\n                                border: .12rem solid #FFFFFF;\n                                border-radius: .3rem;\n                                color: #FFFFFF;\n                                font-weight: 600;\n                            }\n                        }\n                    }\n                }\n\n                .password_btns {\n                    display: flex;\n                    justify-content: flex-end;\n                    padding: 1rem .5rem;\n\n                    button {\n                        width: 5rem;\n                        padding: .5rem .2rem;\n                        cursor: pointer;\n                        outline: none;\n                        border: none;\n                        border-radius: .3rem;\n                        color: #bababa;\n                        font-weight: 600;\n                        font-size: 1rem;\n                    }\n\n                    .save {\n                        background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    }\n                }\n\n                .manage_user_content{\n                    width: 50%;\n\n                    .manage_user_left{\n                        .input_block {\n                            display: flex;\n                            flex-direction: column;\n                            margin: 4rem 0;\n                            padding-left: 5%;\n\n                            label {\n                                font-weight: 400;\n                                font-size: 1rem;\n                                color: #FFFFFF;\n                            }\n\n                            input {\n                                width: 95%;\n                                height: 3rem;\n                                outline: none;\n                                padding-left: .5rem;\n                                background-color: #231B27;\n                                border: .12rem solid #FFFFFF;\n                                border-radius: .3rem;\n                                color: #FFFFFF;\n                                font-weight: 600;\n                            }\n                        }\n                    }\n                }\n\n                .manage_user_password_btns {\n                    display: flex;\n                    justify-content: flex-end;\n                    padding: 1rem .5rem;\n\n                    button {\n                        width: 10rem;\n                        padding: .5rem .2rem;\n                        cursor: pointer;\n                        outline: none;\n                        border: none;\n                        border-radius: .3rem;\n                        color: #bababa;\n                        font-weight: 600;\n                        font-size: 1rem;\n                    }\n\n                    .save {\n                        background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
